import { jsx as o } from "react/jsx-runtime";
import { ComboboxButton as i } from "@headlessui/react";
import { ArrowDown as a } from "../../../icons/arrow-down-icon.mjs";
import { twMerge as t } from "tailwind-merge";
function f({
  arrowButtonClassName: e,
  open: n,
  isDisabled: r,
  As: m = i
}) {
  return /* @__PURE__ */ o(
    m,
    {
      as: "div",
      role: "button",
      className: t(
        "flex h-full items-center",
        "focus-ring",
        "rounded-md",
        r && "cursor-not-allowed",
        e
      ),
      disabled: r,
      children: /* @__PURE__ */ o(
        a,
        {
          className: t("stroke-text-primary main-transition", n && "rotate-180"),
          "aria-hidden": "true"
        }
      )
    }
  );
}
export {
  f as ArrowButton
};
